import Link from "next/link";

export default function ServiceEngagementLinks() {
  return (
    <section className="bg-[#0d0822] py-14 px-6">
      <div className="max-w-5xl mx-auto">
        <p className="text-xs font-semibold uppercase tracking-widest text-indigo-400 mb-8">
          Before you engage
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Link href="/itmtb-how-we-work" legacyBehavior>
            <a className="block bg-[#160f2e] border border-white/10 rounded-xl p-7 hover:border-indigo-500/40 transition-colors group">
              <p className="text-xs uppercase tracking-widest text-indigo-400 mb-3">Engagement Model</p>
              <h3 className="text-lg font-bold text-white mb-3 group-hover:text-indigo-300 transition-colors">
                How we work
              </h3>
              <p className="text-sm text-slate-300 leading-relaxed">
                Discovery sprints, fixed-scope builds, T&amp;M, retainers, and outcome-linked models — with pricing logic and what to expect at each stage.
              </p>
              <span className="mt-5 inline-block text-sm font-semibold text-indigo-400">
                Read the engagement guide →
              </span>
            </a>
          </Link>

          <Link href="/blog/custom-software-development-cost-india" legacyBehavior>
            <a className="block bg-[#160f2e] border border-white/10 rounded-xl p-7 hover:border-indigo-500/40 transition-colors group">
              <p className="text-xs uppercase tracking-widest text-indigo-400 mb-3">Cost Guide</p>
              <h3 className="text-lg font-bold text-white mb-3 group-hover:text-indigo-300 transition-colors">
                What custom software costs in India
              </h3>
              <p className="text-sm text-slate-300 leading-relaxed">
                Pricing models, total cost of ownership, QA investment, and support SLA economics — a full breakdown for enterprise buyers evaluating a build.
              </p>
              <span className="mt-5 inline-block text-sm font-semibold text-indigo-400">
                Read the cost guide →
              </span>
            </a>
          </Link>
        </div>
      </div>
    </section>
  );
}
